import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "search-refined-tag-list" }
const _hoisted_2 = { class: "search-refined-tag-list-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchTagItem = _resolveComponent("SearchTagItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tags, (item) => {
        return (_openBlock(), _createBlock(_component_SearchTagItem, {
          class: "search-refined-tag-list-item",
          key: item.id,
          label: _ctx.getRefinedTagName(item.name),
          alias: item.alias,
          id: item.id,
          active: false,
          deleteIcon: true,
          onSelectTag: _ctx.selectTag
        }, null, 8, ["label", "alias", "id", "onSelectTag"]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 512), [
      [_vShow, _ctx.tags.length != 0]
    ])
  ]))
}